export const HelpLinks = {
  STUDENT_ARCHIVAL:
    "https://help.along.org/hc/en-us/articles/4404029089293-How-do-I-archive-students-",
  GETTING_STARTED:
    "https://help.along.org/hc/en-us/sections/4403436173965-Getting-started-resources",
  CONNECT_CODE:
    "https://help.along.org/hc/en-us/articles/360051356971-How-can-students-use-their-connect-code-to-log-into-Along-for-the-first-time-",
  NEW_REQUEST: "https://help.along.org/hc/en-us/requests/new",
  ALONG_DEMO:
    "https://help.along.org/hc/en-us/articles/4407040243469-Along-demo-for-teachers-and-students",
  WELCOME_PRESENTATION:
    "https://help.along.org/hc/en-us/articles/360055690011-Welcome-students-to-Along-presentation-",
  SIGN_UP:
    "https://help.along.org/hc/en-us/articles/4402633838093-How-can-I-sign-up-to-join-Along-",
  GUARDIAN_CONSENT:
    "https://help.along.org/hc/en-us/articles/360060894551-Parent-Guardian-Notice-and-Consent",
  SEND_REFLECTION:
    "https://help.along.org/hc/en-us/articles/360047598671-How-do-I-send-my-student-a-reflection-question-",
  CAMERA_ISSUES:
    "https://help.along.org/hc/en-us/articles/360048176632-What-should-I-do-if-my-camera-isn-t-working-",
  STUDENT_VIEW_TEACHER_RESPONSES:
    "https://help.along.org/hc/en-us/articles/360047154772-How-does-a-student-see-a-response-to-their-reflection-",
  STUDENT_RESPOND_TO_REFLECTION:
    "https://help.along.org/hc/en-us/articles/360047154712-How-does-a-student-respond-to-their-reflection-question-",
  HELP_DESK: "https://help.along.org/hc/en-us",
  SUMMARY_OF_UPDATES_TO_USER_AGREEMENT_PRIVACY_POLICY_CODE_OF_CONDUCT:
    "https://help.along.org/hc/en-us/articles/360057577211-Updates-to-Terms-and-Policies",
  THIRD_PARTY_SERVICE_PROVIDERS:
    "https://help.along.org/hc/en-us/articles/4403427471757-Third-Party-Providers",
  SECURITY_WHITEPAPER:
    "https://help.along.org/hc/en-us/articles/4403427152781-Security-Whitepaper",
  COOKIE_POLICY:
    "https://help.along.org/hc/en-us/articles/360057568771-Cookie-Policy",
  DIGITAL_MILLENNIUM_COPYRIGHT_ACT_DMCA_NOTIFICATION_GUIDELINES:
    "https://help.along.org/hc/en-us/articles/360047661731-Digital-Millennium-Copyright-Act-DMCA-Notification-Guidelines",
};
